var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { ref: "upload", staticClass: "box-upload", attrs: { id: "holder" } },
      [
        _c("h3", [
          _vm._v("Drop File" + _vm._s(_vm.multiple ? "s" : "") + " Here "),
          _c("br"),
          _vm._v("วางไฟล์เพื่ออัพโหลด")
        ]),
        _c("input", {
          ref: "up",
          attrs: {
            type: "file",
            id: "items",
            name: "items[]",
            required: "",
            multiple: _vm.multiple
          },
          on: {
            change: function($event) {
              _vm.onChange($event, "click")
            }
          }
        })
      ]
    ),
    _vm.itemsDisplay.length > 0
      ? _c("div", { staticClass: "result" }, [
          _c("p", [_vm._v("Result File")]),
          _c(
            "ol",
            _vm._l(_vm.itemsDisplay, function(item, index) {
              return _c("li", { key: index }, [
                _c("span", [_vm._v("file name:")]),
                _vm._v(" " + _vm._s(item.name) + "  "),
                _c("span", [_vm._v("size")]),
                _vm._v(" " + _vm._s(item.size) + "\n                "),
                _vm.isUpload == false
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            _vm.removeItem(index)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-times" }),
                        _vm._v(" Remove")
                      ]
                    )
                  : _vm._e()
              ])
            })
          ),
          _c("p", [
            _c("span", [_vm._v("Total Size:")]),
            _vm._v(" " + _vm._s(_vm.itemsTotalSize))
          ]),
          _vm.errorMsg != ""
            ? _c("p", { staticClass: "has-text-danger" }, [
                _vm._v(_vm._s(_vm.errorMsg))
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        " ** igs, pdf, dwg, dxf, solidwork, step, iges, jpg, png, gif, xls, xlsx, doc, docx, txt, ai, ps,zip ,rar is allow to upload\n       "
      ),
      _c("br"),
      _vm._v("Maxinum upload size is 100MB / Queue\n     ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f6e267c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6e267c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/upload.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1f6e267c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/upload.vue
// module chunks = 0 1 2 3 4 13 14 16 17 30 31 33 36